import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiRequestError, ApiServerError, unwrapFetch2 } from '../fetch';
import * as Hub from '../ogm-hub';

export const fetchLocationLevelPricingEnabled = createAsyncThunk(
	'CustomerSettingsSlice/fetchLocationLevelPricingEnabled',
	async (supplierId: number, { rejectWithValue }) => {
		try {
			const locationLevelPricingResponse = await unwrapFetch2(
				Hub.ReportController.IsLocationLevelPricingEnabled(supplierId)
			);

			const result = {
				supplierId,
				locationLevelPricingEnabled:
					locationLevelPricingResponse.locationLevelPricingEnabled,
			};

			return result;
		} catch (err) {
			if (err instanceof ApiRequestError) {
				return rejectWithValue(err.errors);
			}
			if (err instanceof ApiServerError) {
				return rejectWithValue(err.response);
			}
			throw err;
		}
	}
);

export interface ICustomerSettingsState {
	locationLevelPricingEnabled: Record<number, boolean>;
}
const initialState: ICustomerSettingsState = {
	locationLevelPricingEnabled: {},
};

export const customerSettingsSlice = createSlice({
	name: 'customerSettingsSlice',
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(
			fetchLocationLevelPricingEnabled.fulfilled,
			(state, action) => {
				const newSettings = { ...state.locationLevelPricingEnabled };
				newSettings[action.payload.supplierId] =
					action.payload.locationLevelPricingEnabled;
				state.locationLevelPricingEnabled = newSettings;
			}
		);

		// NOTE: Even though it is exported, you cannot access the typesafe version of this action from the customer duck.
		builder.addCase('@ca:LOADED_CUSTOMERS_PAGE_SUCCESS', (state) => {
			state.locationLevelPricingEnabled =
				initialState.locationLevelPricingEnabled;
		});
	},
});
